import { Select, Label, IOption } from '@gcl/react-core';
import * as React from 'react';
import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect';
import { BooleanFilter, BooleanFilterOptions, IFilterInputBaseProps } from '../searchFilter.models';
import { getFilterValue } from '../searchFilter.services';

export interface IBooleanFilterInputProps extends IFilterInputBaseProps<BooleanFilter> {}

export const BooleanFilterInput: React.FunctionComponent<IBooleanFilterInputProps> = ({
  fieldConfig,
  onChange,
  filter = {},
  disabled = false,
}) => {
  const { fieldName, displayName, disable, booleanSelectOptions = BooleanFilterOptions } = fieldConfig;
  const [localValue, setLocalValue] = React.useState<IOption<boolean> | undefined>(booleanSelectOptions[0]);
  const getOption = (value?: boolean): IOption<boolean> => {
    if (value === false) return booleanSelectOptions[2];
    if (value === true) return booleanSelectOptions[1];
    return booleanSelectOptions[0];
  };

  useDeepCompareEffectNoCheck(() => {
    setLocalValue(getOption(getFilterValue(fieldName, filter)));
  }, [JSON.stringify(filter)]);

  return (
    <>
      <Label labelFor={fieldName}>{displayName}</Label>
      <Select
        disabled={disabled || disable}
        id={fieldName}
        onChange={(newValue: IOption<boolean>[]) => {
          setLocalValue(newValue.length > 0 ? newValue[0] : undefined);
          onChange(fieldName, newValue.length > 0 ? newValue[0].data : undefined);
        }}
        value={localValue ? [localValue] : undefined}
        options={booleanSelectOptions}
        allowSearch={false}
        clearable={false}
      />
    </>
  );
};
